import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _get from 'lodash/get';

import {
  getUsers,
  selectUser,
  selectAllUsers,
  deselectAllUsers,
  filterUserData,
  resetUsersData,
  deleteSelected,
} from 'modules/memberLogin/modules/users/actions';
import { getGroups } from 'modules/memberLogin/modules/groups/actions';
import Scan from './Scan';

import {
  scanBarcode,
  addScannerComponent,
  updateChecked,
  addLoyaltyComponent,
} from './actions';
import { appHasComponent } from '../../../../utils';

const mapStateToProps = (state, ownProps) => {
  const appname = ownProps.match.params.appname;
  const loyaltyComponentEnabled = appHasComponent(
    state.editor.structure,
    'Loyalty',
  );
  return {
    ...ownProps,
    ...state.auth.users,
    accountId: state.account.auth.profile.account,
    appname: _get(
      state,
      `editor.shared.appName.${appname}.meta.title`,
      appname,
    ),
    loyaltyComponentEnabled,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getUsers: () => dispatch(getUsers(ownProps.match.params.appname)),
  getGroups: () => dispatch(getGroups(ownProps.match.params.appname)),
  onScanBarcode: (appname, uid) => dispatch(scanBarcode(appname, uid)),
  onAddScannerComponent: () =>
    dispatch(
      addScannerComponent(ownProps.match.params.appname, ownProps.history),
    ),
  onUpdateChecked: (hasScannerAccess, user) =>
    dispatch(
      updateChecked(ownProps.match.params.appname, hasScannerAccess, user),
    ),
  onAddLoyaltyComponent: () =>
    dispatch(
      addLoyaltyComponent(ownProps.match.params.appname, ownProps.history),
    ),
  onSelect: key => dispatch(selectUser(key)),
  onSelectAllUsers: () => dispatch(selectAllUsers()),
  onDeselectAllUsers: () => dispatch(deselectAllUsers()),
  onFilterUserData: filter => dispatch(filterUserData(filter)),
  resetUsersData: () => dispatch(resetUsersData()),
  onDeleteSelected: (selected, chunks) =>
    dispatch(deleteSelected(ownProps.match.params.appname, selected, chunks)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Scan));
